export default __webpack_public_path__ + "static/img-app-pension-ddda960f951a391a821e1b0dc3e35cf0.webp";